import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import steps from './steps';
export default {
  __name: 'index',
  setup(__props) {
    const i18n = useI18n();
    let driver = null;
    onMounted(() => {
      driver = new Driver({
        // 禁止点击蒙版关闭
        allowClose: false,
        closeBtnText: i18n.t('msg.guide.close'),
        nextBtnText: i18n.t('msg.guide.next'),
        prevBtnText: i18n.t('msg.guide.prev')
      });
    });
    const onClick = () => {
      driver.defineSteps(steps(i18n));
      driver.start();
    };
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_tooltip, {
        content: _ctx.$t('msg.navBar.guide')
      }, {
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          id: "guide-start",
          icon: "guide",
          onClick: onClick
        })]),
        _: 1
      }, 8, ["content"])]);
    };
  }
};